let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1GTZW")).then(() => parcelRequire('ggb3Y'));